export const  TIMELINE={
    TIMELINE_STATUS_INSERT: "TIMELINE_STATUS_INSERT",
    TIMELINE_CLOCKDATA_INSERT: "TIMELINE_CLOCKDATA_INSERT",
    TIMELINE_PLAY_INSERT: "TIMELINE_PLAY_INSERT",
    TIMELINE_PAUSE_INSERT: "TIMELINE_PAUSE_INSERT",
    TIMELINE_SPEED_INSERT: "TIMELINE_SPEED_INSERT",
    TIMELINE_DATE_INSERT: "TIMELINE_DATE_INSERT",
};
  